import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
export const ResultSection: React.FC = () => {
  const results = ['Entrás a sesión con más claridad.', 'Sabés qué priorizar.', 'Intervenís con más confianza.', 'Medís avances con más orden.', 'Cerrás mejor cada encuentro.', 'Trabajás con más calma profesional.'];
  return <section className="py-12 md:py-20 px-4 bg-navy-900 relative" data-id="element-119">
      <div className="max-w-md md:max-w-4xl mx-auto text-center" data-id="element-120">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-121">
          <div className="inline-flex items-center justify-center p-2 md:p-3 bg-gold-500/10 rounded-full mb-4 md:mb-6" data-id="element-122">
            <Sparkles className="w-6 h-6 md:w-8 md:h-8 text-gold-500" data-id="element-123" />
          </div>
          <h2 className="text-2xl md:text-5xl font-bold mb-8 md:mb-12 text-white" data-id="element-124">
            EL RESULTADO:
          </h2>

          <div className="space-y-3 md:space-y-0 md:grid md:grid-cols-2 md:gap-6 text-left" data-id="element-125">
            {results.map((result, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.08
          }} className="bg-navy-800 p-4 md:p-6 rounded-lg md:rounded-xl border border-navy-700 flex items-center gap-3 md:gap-4" data-id="element-126">
                <div className="w-2 h-2 bg-gold-500 rounded-full shrink-0" data-id="element-127"></div>
                <span className="text-base md:text-lg text-gray-200 font-medium" data-id="element-128">
                  {result}
                </span>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
};